import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import { PageSection } from '../../../Layout';
import ids from '../../QestIds';
import { AsOversizeCorrectionDataSection, AsPreparationSection } from './Sections';
import AsCompactionDataSection from './Sections/CompactionDataSection';
import AsCompactionEquipmentSection from './Sections/CompactionEquipmentSection';
import AsFieldResultsSection from './Sections/FieldResultsSection';
import AsResultsSection from './Sections/ResultsSection';

const qestIds = [ids.convertedWetDensity.AS_1289_5_7_1.rev2006];

let Worksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  const isOversizeMaterialPresent = useSelector(
    pipe(createWorksheetSelector!('Preparation.Screening.OversizePercentWet'), (i) => i > 0)
  );

  const materialNotSuitableDueToOversize = useSelector(
    pipe(createWorksheetSelector!('Preparation.Screening.MaterialNotSuitableDueToOversize'), valueOrDefault(false))
  );

  return (
    <>
      <PageSection heading="Preparation">
        <AsPreparationSection />
      </PageSection>
      {!materialNotSuitableDueToOversize && (
        <>
          {isOversizeMaterialPresent && (
            <PageSection heading="Oversize Correction Data">
              <AsOversizeCorrectionDataSection />
            </PageSection>
          )}
          <PageSection heading="Field Results">
            <AsFieldResultsSection></AsFieldResultsSection>
          </PageSection>
          <PageSection heading="Compaction">
            <AsCompactionEquipmentSection />
            <AsCompactionDataSection />
          </PageSection>
        </>
      )}
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <WorksheetResultsSection heading="Results">
        <AsResultsSection />
      </WorksheetResultsSection>
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

Worksheet.qestIds = qestIds;
const AsConvertedWetDensityWorksheet = withInjectedProps(Worksheet);

export { AsConvertedWetDensityWorksheet };
export default AsConvertedWetDensityWorksheet;
